require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /Users/cjcenizal/Documents/GitHub/Mine/flexbox-patterns-site/node_modules/core-js/modules/es6.array.species.js
// module id = 296
// module chunks = 0